import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { BikeleasingBIcon } from 'probonio-shared-ui/component/icon';
import React from 'react';
import { BenefitMetadataExtensionInterface } from '../interface/benefit-metadata.extension.interface';

/**
 * The retired v1 benefit only shows up in the activation history of ended activations.
 */
export class LegacyBikeleasingBenefitMetadataExtension extends BenefitMetadataExtensionInterface {
  benefitId: BenefitDTOBenefitEnum = BenefitDTOBenefitEnum.Bikeleasing;
  get Icon(): React.ComponentType<SvgIconProps> {
    return BikeleasingBIcon;
  }
}
